/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { hostingHandDuocolor } from "../assets/hosting-hand-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconHostingHandDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={hostingHandDuocolor.svg} />
);

IllustrativeIconHostingHandDuocolor.displayName = "IllustrativeIconHostingHandDuocolor";
